// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Importação adicional para o Firestore
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBrQRbHIWjuUSVEbFHia3PijtOvOONPlPo",
  authDomain: "expectate-2fff0.firebaseapp.com",
  databaseURL: "https://expectate-2fff0-default-rtdb.firebaseio.com",
  projectId: "expectate-2fff0",
  storageBucket: "expectate-2fff0.appspot.com",
  messagingSenderId: "252944015878",
  appId: "1:252944015878:web:e84231d2e4647c95789987",
  measurementId: "G-9KK14EGS7E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const firestore = getFirestore(app);

export { firestore, app, analytics };